// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/main.scss
// module id = 712
// module chunks = 0